
<mat-toolbar class="header-toolbar" style="position:sticky;top:0px">

  <!-- Hamburger (Mobile only) -->
  <button class="hamburger-btn" id="header-hamburger-btn" (click)="toggleMobileMenu()" aria-label="Toggle navigation menu" title="Toggle navigation menu">
    <mat-icon aria-hidden="true">{{ mobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
    <span class="visually-hidden">Toggle navigation menu</span>
  </button>

  <!-- Logo -->
  <a href="/" routerLink="/" class="logo-area text-decoration-none" id="header-logo">
    <img src="../../../assets/img/logo001.png" alt="BtechMart" class="logo-img" />
  </a>

  <!-- Search Bar — desktop -->
  <div class="search-area desktop-search">
    <div class="search-box" id="header-search-box">
      <mat-icon class="search-prefix-icon">search</mat-icon>
      <input type="text" placeholder="Search products, services, leads..." [(ngModel)]="headerSearch" (ngModelChange)="onSearchInput($event)" class="search-input" id="header-search-input" />
      <button class="search-cta" id="header-search-btn" (click)="gotoSearch()">Search</button>
    </div>
  </div>

  <!-- Spacer -->
  <span class="flex-spacer"></span>

  <!-- City -->
  <span class="nav-chip location-chip" *ngIf="city" id="header-city">
    <mat-icon class="chip-icon">location_on</mat-icon>
    <span class="chip-label">{{ city }}</span>
  </span>

  <!-- Advertise -->
  <span class="nav-chip desktop-chip" (click)="openPlans()" id="header-advertise-btn">
    <mat-icon class="chip-icon">campaign</mat-icon>
    <span class="chip-label">Advertise</span>
  </span>

  <!-- Free Listings dropdown -->
   <span class="nav-chip desktop-chip leads-chip" style="margin-right: 6px;" (click)="gotoLeads()" id="header-leads-btn">
    <mat-icon class="chip-icon">mail</mat-icon>
    <span class="chip-label">Leads</span>
  </span>

  <div class="dropdown d-inline-block">
    <span class="nav-chip desktop-chip listing-chip" role="button" tabindex="0" data-bs-toggle="dropdown" aria-expanded="false" id="header-listing-btn" style="cursor: pointer;">
      <mat-icon class="chip-icon">add_circle_outline</mat-icon>
      <span class="chip-label">Free Listing</span>
      <mat-icon class="chip-arrow">expand_more</mat-icon>
    </span>
    <ul class="dropdown-menu dropdown-menu-end hdr-menu">
      <li *ngIf="userData?.role != 'guest'">
        <button class="dropdown-item d-flex align-items-center" (click)="openFreeListingBuyer()" id="listing-buyer-btn">
          <mat-icon class="me-2">person</mat-icon> For Buyer
        </button>
      </li>
      <li>
        <button class="dropdown-item d-flex align-items-center" (click)="openFreeListingSeller()" id="listing-seller-btn">
          <mat-icon class="me-2">store</mat-icon> For Seller
        </button>
      </li>
    </ul>
  </div>

  <!-- Cart -->
  <span class="nav-chip icon-chip" *ngIf="userData" (click)="gotoLinksCard(cartData)" id="header-cart-btn">
    <span class="cart-icon-wrap">
      <mat-icon>shopping_cart</mat-icon>
      <span class="cart-badge" *ngIf="cartData > 0">{{ cartData }}</span>
    </span>
  </span>

  <!-- Help dropdown -->
  <div class="dropdown d-inline-block">
    <span class="nav-chip icon-chip desktop-chip" role="button" tabindex="0" data-bs-toggle="dropdown" aria-expanded="false" id="header-help-btn" style="cursor: pointer;">
      <mat-icon>help_outline</mat-icon>
      <span class="chip-label">Help</span>
    </span>
    <ul class="dropdown-menu dropdown-menu-end hdr-menu">
      <li>
        <button class="dropdown-item d-flex align-items-center" (click)="gotoLinks('/feedback')" id="help-feedback-btn">
          <mat-icon class="me-2">rate_review</mat-icon> Feedback
        </button>
      </li>
      <li>
        <button class="dropdown-item d-flex align-items-center" (click)="gotoLinks('/complain')" id="help-complain-btn">
          <mat-icon class="me-2">report_problem</mat-icon> Complaint
        </button>
      </li>
      <li>
        <button class="dropdown-item d-flex align-items-center" (click)="gotoLinks('/contact-us')" id="help-contact-btn">
          <mat-icon class="me-2">phone</mat-icon> Contact Us
        </button>
      </li>
    </ul>
  </div>

  <!-- Sign In (not logged in) -->
  <span class="nav-chip signin-chip" *ngIf="!userData" (click)="openLoginDialog()" id="header-signin-btn">
    <mat-icon class="chip-icon">account_circle</mat-icon>
    <span class="chip-label">Sign In</span>
  </span>

  <!-- User Menu (logged in) -->
  <div class="dropdown d-inline-block" *ngIf="userData">
    <span class="nav-chip user-chip" role="button" tabindex="0" data-bs-toggle="dropdown" aria-expanded="false" id="header-user-btn" style="cursor: pointer;">
      <span class="avatar-bubble">{{ userData?.fullName?.charAt(0)?.toUpperCase() }}</span>
      <span class="chip-label desktop-chip-label">{{ userData?.fullName?.split(' ')[0] }}</span>
      <mat-icon class="chip-arrow desktop-chip-label">expand_more</mat-icon>
    </span>
    <ul class="dropdown-menu dropdown-menu-end hdr-menu user-hdr-menu">
      <!-- User Header -->
      <li (click)="$event.stopPropagation()">
        <div class="menu-user-header px-3 py-2 d-flex align-items-center">
          <span class="menu-avatar me-2">{{ userData?.fullName?.charAt(0)?.toUpperCase() }}</span>
          <div class="menu-user-info">
            <div class="menu-user-name fw-bold">{{ userData?.fullName }}</div>
            <div class="menu-user-role text-muted small">{{ userData?.role }}</div>
          </div>
        </div>
      </li>
      <li><hr class="dropdown-divider"></li>
      <li *ngIf="userData?.role == 'service_provider' || userData?.role == 'seller' || userData?.role == 'both'">
        <button class="dropdown-item d-flex align-items-center" routerLink="/account" id="user-dashboard-btn">
          <mat-icon class="me-2">dashboard</mat-icon> My Dashboard
        </button>
      </li>
      <li *ngIf="userData?.role == 'service_provider' || userData?.role == 'seller' || userData?.role == 'both'">
        <button class="dropdown-item d-flex align-items-center" routerLink="/account/my-leads" id="user-leads-btn">
          <mat-icon class="me-2">leaderboard</mat-icon> My Leads
        </button>
      </li>
      <li>
        <button class="dropdown-item d-flex align-items-center" routerLink="/account/my-profile" id="user-profile-btn">
          <mat-icon class="me-2">manage_accounts</mat-icon> My Profile
        </button>
      </li>
      <li *ngIf="userData?.role == 'service_provider' || userData?.role == 'seller' || userData?.role == 'both' || userData?.role == 'guest'">
        <button class="dropdown-item d-flex align-items-center" routerLink="/account/my-order" id="user-orders-btn">
          <mat-icon class="me-2">receipt_long</mat-icon> My Orders/Bookings
        </button>
      </li>
      <li><hr class="dropdown-divider"></li>
      <li>
        <button class="dropdown-item d-flex align-items-center logout-item" (click)="gotoLogOut()" id="user-logout-btn">
          <mat-icon class="me-2">logout</mat-icon> Logout
        </button>
      </li>
    </ul>
  </div>

</mat-toolbar>

<!-- Mobile Search Bar -->
<div class="mobile-search-bar" id="mobile-search-bar">
  <div class="search-box">
    <mat-icon class="search-prefix-icon">search</mat-icon>
    <input type="text" placeholder="Search products, services..." class="search-input" id="mobile-search-input" [(ngModel)]="headerSearch" (ngModelChange)="onSearchInput($event)" />
  </div>
</div>

<!-- Mobile Slide Nav -->
<div class="mobile-overlay" [class.active]="mobileMenuOpen" (click)="toggleMobileMenu()"></div>
<nav class="mobile-drawer" [class.open]="mobileMenuOpen" id="mobile-nav-drawer">
  <div class="drawer-header">
    <img src="../../../assets/img/logo001.png" alt="BtechMart" class="drawer-logo" />
    <button class="drawer-close-btn" (click)="toggleMobileMenu()" aria-label="Close navigation menu">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="drawer-body">
    <!-- Logged in user card -->
    <div class="drawer-user-card" *ngIf="userData">
      <span class="drawer-avatar">{{ userData?.fullName?.charAt(0)?.toUpperCase() }}</span>
      <div>
        <div class="drawer-user-name">{{ userData?.fullName }}</div>
        <div class="drawer-user-role">{{ userData?.role }}</div>
      </div>
    </div>
    <!-- Sign in prompt -->
    <div class="drawer-signin-card" *ngIf="!userData" (click)="openLoginDialog(); toggleMobileMenu()">
      <mat-icon>account_circle</mat-icon>
      <span>Sign In / Register</span>
    </div>

    <ul class="drawer-links">
      <li (click)="gotoLinks('/'); toggleMobileMenu()">
        <mat-icon>home</mat-icon> Home
      </li>
        <li (click)="gotoLeads(); toggleMobileMenu()">
        <mat-icon>mail</mat-icon> Leads
      </li>
      <li (click)="openFreeListingSeller(); toggleMobileMenu()">
        <mat-icon>add_circle_outline</mat-icon> Free Listing
      </li>
      <li (click)="openPlans(); toggleMobileMenu()">
        <mat-icon>campaign</mat-icon> Advertise with Us
      </li>
      <li (click)="gotoHiring(); toggleMobileMenu()">
        <mat-icon>work</mat-icon> Hiring
      </li>
      <li (click)="gotoLinks('/feedback'); toggleMobileMenu()">
        <mat-icon>rate_review</mat-icon> Send Feedback
      </li>
      <li (click)="gotoLinks('/contact-us'); toggleMobileMenu()">
        <mat-icon>phone</mat-icon> Contact Us
      </li>
      <li *ngIf="userData?.role == 'service_provider' || userData?.role == 'seller' || userData?.role == 'both'"
        (click)="gotoMyDashboard(); toggleMobileMenu()">
        <mat-icon>dashboard</mat-icon> My Dashboard
      </li>
      <li *ngIf="userData" (click)="gotoLogOut(); toggleMobileMenu()" class="drawer-logout">
        <mat-icon>logout</mat-icon> Logout
      </li>
    </ul>
  </div>

  <!-- Drawer Footer -->
  <div class="drawer-footer">
    <div class="drawer-footer-brand">
      <strong>Btechmart</strong>
      <span class="drawer-beta-badge">BETA v1.0</span>
    </div>
    <p class="drawer-footer-desc">Your ultimate B2B marketplace.</p>
    <p class="drawer-footer-copy">&copy; 2026 Btechmart. All rights reserved.</p>
  </div>
</nav>

<!-- ========================================
   CATEGORY STRIP (Home page only)
======================================== -->
<div class="category-strip" id="category-strip">
  <div class="cat-strip-inner">

    <!-- "All" pinned left -->
    <div class="cat-pinned-left">
      <div class="cat-tile all-tile">
        <div class="cat-icon-ring">
          <img src="../../../assets/img/topCate/shape.png" class="cat-img" alt="All" />
        </div>
        <span class="cat-label">All</span>
      </div>
      <div class="cat-divider"></div>
    </div>

    <!-- Scroll arrow left -->
    <button class="cat-arrow cat-arrow-left" id="cat-scroll-left" (click)="scrollCatLeft()" aria-label="Scroll left">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <!-- Scrollable categories -->
    <div class="cat-scroll-area" id="cat-scroll-area">
      <div class="cat-scroll-track">
        <div class="cat-tile" *ngFor="let data of allCategoryData" (click)="gotoTabs(data)">
          <div class="cat-icon-ring">
            <img [src]="data.url" class="cat-img" [alt]="data.name" />
          </div>
          <span class="cat-label">{{ data.name?.length > 15 ? (data.name | slice:0:15) + '...' : data.name }}</span>
        </div>
      </div>
    </div>

    <!-- Scroll arrow right -->
    <button class="cat-arrow cat-arrow-right" id="cat-scroll-right" (click)="scrollCatRight()" aria-label="Scroll right">
      <mat-icon>chevron_right</mat-icon>
    </button>

  </div>
</div>